export default __webpack_public_path__ + "static/media/pers2_pc@2x.24db866b.jpg";